const NOW = '2026-06-16T13:13:00.000Z';

const CUSTOMERS = [
  {
    id: 7,
    display_name: 'Agency XYZ',
    external_id: 'sub_12345',
    tenant_id: 3,
    netbox_tenant_id: 42,
    netbox_synced_at: NOW,
    services_count: 2,
    domains_count: 3,
    email: 'office@agency-xyz.de',
  },
  {
    id: 8,
    display_name: 'Bäckerei Müller',
    external_id: null,
    tenant_id: 3,
    netbox_tenant_id: 43,
    netbox_synced_at: NOW,
    services_count: 1,
    domains_count: 1,
    email: 'mueller@example.com',
  },
  {
    id: 9,
    display_name: 'Solo-Dev Tom',
    external_id: 'sub_98765',
    tenant_id: 3,
    netbox_tenant_id: 44,
    netbox_synced_at: '2026-06-15T22:00:00.000Z',
    services_count: 1,
    domains_count: 2,
    email: 'tom@example.dev',
  },
];

const SERVICES_BY_CUSTOMER = {
  7: [
    { id: 1, plugin_id: 'hosting-enhance', kind: 'hosting', account_id: 'enhance-org_42', subscription_id: 'sub_12345', status: 'active' },
    { id: 2, plugin_id: 'vps-proxmox', kind: 'vps', account_id: 'vm_88', subscription_id: 'sub_12346', status: 'suspended' },
  ],
  8: [
    { id: 3, plugin_id: 'hosting-enhance', kind: 'hosting', account_id: 'enhance-org_88', subscription_id: null, status: 'active' },
  ],
  9: [
    { id: 4, plugin_id: 'hosting-enhance', kind: 'hosting', account_id: 'enhance-org_19', subscription_id: 'sub_98765', status: 'active' },
  ],
};

const DOMAINS_BY_CUSTOMER = {
  7: [
    { id: 11, domain: 'agency-xyz.de', kind: 'primary', source: 'bundle-workflow' },
    { id: 12, domain: 'www.agency-xyz.de', kind: 'alias', source: 'bundle-workflow' },
    { id: 13, domain: 'blog.agency-xyz.de', kind: 'primary', source: 'customer' },
  ],
  8: [{ id: 14, domain: 'baeckerei-mueller.de', kind: 'primary', source: 'bundle-workflow' }],
  9: [
    { id: 15, domain: 'tom.dev', kind: 'primary', source: 'bundle-workflow' },
    { id: 16, domain: 'staging.tom.dev', kind: 'primary', source: 'bundle-workflow' },
  ],
};

export function customersListFixture({ tenantId = '', search = '' } = {}) {
  let list = CUSTOMERS;
  if (tenantId) list = list.filter((c) => String(c.tenant_id) === String(tenantId));
  if (search) {
    const needle = search.toLowerCase();
    list = list.filter(
      (c) =>
        (c.display_name ?? '').toLowerCase().includes(needle) ||
        (c.email ?? '').toLowerCase().includes(needle) ||
        (c.external_id ?? '').toLowerCase().includes(needle),
    );
  }
  return { customers: list };
}

export function customerDetailFixture(id) {
  const customer = CUSTOMERS.find((c) => String(c.id) === String(id)) ?? CUSTOMERS[0];
  return {
    customer,
    services: SERVICES_BY_CUSTOMER[customer.id] ?? [],
    domains: DOMAINS_BY_CUSTOMER[customer.id] ?? [],
  };
}
